import React from 'react';
import { withTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import About4 from '../Elements/About4';

var bnrimg = require('../../images/banner/proteccion-datos.jpg');

class Home4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        const { t } = this.props;
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title={t('pages.personalData.banner.title')} pagename={t('pages.personalData.banner.pagename')} description={t('pages.personalData.banner.description')} bgimage={bnrimg}/>
                    <About4 bgcolor="bg-gray" />
                </div>

                <Footer />
            </>
        );
    };
};

export default withTranslation()(Home4);